import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import Help from './Help';
import a from '../../../redux/actions';
import s from '../../../redux/selectors';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const HomeSize = ({
  t,
  isMetric,
  inputFootprintHousingSquarefeet,
  updateNumericInput,
}) => (
  <div className="cc-component__question">
    <h4>
      {t('Living space area')}
      <Help t={t} helpKey="input_footprint_housing_squarefeet" />
    </h4>
    <div className="input-group">
      <input
        aria-label={t('Living space area')}
        className="form-control cc-component__question-input"
        onChange={e => updateNumericInput({ housing_squarefeet: e.target.value })}
        value={inputFootprintHousingSquarefeet.inputDisplay}
        placeholder={inputFootprintHousingSquarefeet.defaultDisplay}
      />
      <span className="input-group-addon">{isMetric ? t('m', { ns: 'units' }) : t('ft', { ns: 'units' })}<sup>2</sup></span>
    </div>
  </div>
);

HomeSize.propTypes = {
  t: PropTypes.func.isRequired,
  updateNumericInput: PropTypes.func.isRequired,
  isMetric: PropTypes.bool.isRequired,
  inputFootprintHousingSquarefeet: types.UserInput.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
  'inputFootprintHousingSquarefeet',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateNumericInput',
  ]),
  dispatch,
);

export default wrap(
  withT('home'),
  connect(mapStateToProps, mapDispatchToProps),
  HomeSize,
);

